<template>
    <vx-card fixed-height="true">
        <vs-divider>Seleccione el metodo de edición a usar</vs-divider>
        <div>
            <div style="display: inline-flex; margin: 0px 3px 0px 3px">
                <table align="center">
                    <tr>
                        <td>
                            <ul class="flex mt-2">
                                <li>
                                    <vs-radio v-model="tipo" class="ml-2" vs-name="radios1tipo" vs-value="0" @change="radbuttonxSeleccion();">Edición por selección(Textos-Guías)</vs-radio>
                                </li>
                                <li>
                                    <vs-radio v-model="tipo" class="ml-2" vs-name="radios1tipo" vs-value="1" @change="radbuttonxGrupos();">Edición por grupos(Textos-Guías)</vs-radio>
                                </li>
                                <li>
                                    <vs-radio v-model="tipo" class="ml-2" vs-name="radios1tipo" vs-value="2" @change="radbuttonxCombos();">Edición de combos</vs-radio>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <vs-row v-if="tipo == 0">
            <vs-divider>Búsqueda y selección de producto(s)</vs-divider>
            <!-- {{ arrayConfiguration }} -->
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                <div>
                    <table align="center">
                        <tr>
                            <td width="1000">
                                <!-- <v-select style="width: 100%;" placeholder="--Buscar y seleccionar--" multiple :closeOnSelect="false" v-model="pro_codigo" label="pro_nombre" class="mb-4" :options="productosDisponibles" :reduce="(Productos) => Productos.pro_codigo" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
                                <v-select style="width: 100%;" placeholder="--Buscar y seleccionar--" multiple :closeOnSelect="false" v-model="pro_codigo" label="nombreCompleto" class="mb-4" :options="productosDisponibles" :reduce="(productosDisponibles) => productosDisponibles.pro_codigo" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            </td>
                            <td width="150">
                                <vs-button @click="AgregarItemsTabla();" color="success" type="relief">Agregar a la tabla</vs-button>&emsp;
                            </td>
                        </tr>
                    </table>
                </div>
            </vs-col>
        </vs-row>
        <vs-row v-if="tipo == 1">
            <vs-divider>Edición por grupos</vs-divider>
            <!-- {{ arrayConfiguration }} -->
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                <div>
                    <table align="center">
                        <tr>
                            <td width="500">
                                <font style="font-size: 11.5px">&nbsp;Serie (Obligatorio)</font><br>
                                <v-select :options="SeriesArray" :reduce="SeriesArray => SeriesArray.id_serie" label="nombre_serie" class="w-full h-100" placeholder="--Seleccione una serie--" v-model="tabSeleccionbusqueda.serieSeleccionada" @input="metodoEjecucionSerie()" />
                            </td>
                            <td width="500">
                                <div v-if="tabSeleccionbusqueda.serieSeleccionada">
                                    <font style="font-size: 11.5px">&nbsp;Área (Opcional)</font><br>
                                    <v-select :options="AreasxSerieArray" :reduce="AreasxSerieArray => AreasxSerieArray.idarea" label="nombrearea" class="w-full h-100" placeholder="--Seleccione un area--" v-model="tabSeleccionbusqueda.areaSeleccionada" @input="metodoEjecucionArea()" />
                                </div>
                            </td>
                        </tr>
                    </table>
                    <table align="center" v-if="tabSeleccionbusqueda.serieSeleccionada">
                        <tr>
                            <td>
                                <ul class="flex mt-2">
                                    <li>
                                        <vs-radio v-model="tipoproducto" class="ml-2" vs-name="radios1tipoproducto" vs-value="1" @change="AgregarItemsTabla2()">Textos y Guías</vs-radio>
                                    </li>
                                    <li>
                                        <vs-radio v-model="tipoproducto" class="ml-2" vs-name="radios1tipoproducto" vs-value="2" @change="AgregarItemsTabla2()">Solo Textos</vs-radio>
                                    </li>
                                    <li>
                                        <vs-radio v-model="tipoproducto" class="ml-2" vs-name="radios1tipoproducto" vs-value="3" @change="AgregarItemsTabla2()">Solo Guías</vs-radio>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                </div>
            </vs-col>
        </vs-row>
        <vs-row v-if="tipo == 2">
            <vs-divider>Edición por combos</vs-divider>
            <!-- {{ arrayConfiguration }} -->
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                <div>
                    <table align="center">
                        <tr>
                            <td width="1000">
                                <div>
                                    <font style="font-size: 11.5px">&nbsp;Área (Opcional)</font><br>
                                    <v-select :options="AreasxSerieCombosArray" :reduce="AreasxSerieCombosArray => AreasxSerieCombosArray.idarea" label="nombrearea" class="w-full h-100" placeholder="--Seleccione un area--" v-model="tabSeleccionbusqueda.areaSeleccionada" @input="metodoEjecucionArea()" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-divider>Cantidad de producto/s a modificar: {{ DatosAcumuladosStockMasivo.length }}</vs-divider>
                <vs-table search :data="DatosAcumuladosStockMasivo" :max-items="DatosAcumuladosStockMasivo.length" no-data-text="Aún no se ha agregado ningún producto">
                    <template slot="thead">
                        <vs-th width="100">Codigo</vs-th>
                        <vs-th width="700">Nombre</vs-th>
                        <vs-th width="250">Stock General</vs-th>
                        <vs-th width="350">Stock Facturas Prolipa</vs-th>
                        <vs-th width="350">Stock Facturas Calmed</vs-th>
                        <vs-th width="350">Stock Notas Prolipa</vs-th>
                        <vs-th width="350">Stock Notas Calmed</vs-th>
                        <vs-th width="200">Acciones</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, k) in data" :key="k" height="100">
                            <vs-td><span><b style="font-size: 13px;">{{ tr.pro_codigo }}</b></span></vs-td>
                            <vs-td align="left">
                                <span><b style="font-size: 13px;">{{ tr.pro_nombre }}</b></span><br>
                                <div v-if="tr.iniciales_con_nombres">
                                    <div v-for="item in tr.iniciales_con_nombres.split(',')" :key="item">
                                        <b>-</b> {{ item }}
                                    </div>
                                </div>
                            </vs-td>
                            <vs-td align="center" style="cursor: pointer;">
                                <vs-tooltip text="No se incluye el valor reservado en proformas." position="bottom" color="primary">
                                    <template>‎</template>
                                    <span><b style="font-size: 13px;">
                                            {{ tr.pro_reservar }}
                                        </b></span>
                                </vs-tooltip>
                            </vs-td>
                            <vs-td align="center">
                                <vs-tooltip text="Máx. 5 dígitos" position="bottom" color="primary">
                                    <template>‎</template>
                                    <vs-input class="w-full hacer-click" placeholder="Cantidad" min="0" v-model="tr.pro_stock" @blur="EstablecerDefaultVacio(tr, 'pro_stock')" @input="actualizarProReservar(tr)" @keypress="validateInput($event, tr)" @paste="validatePaste" maxlength="5" />
                                </vs-tooltip>
                            </vs-td>
                            <vs-td align="center">
                                <vs-tooltip text="Máx. 5 dígitos" position="bottom" color="primary">
                                    <template>‎</template>
                                    <vs-input class="w-full hacer-click" placeholder="Cantidad" min="0" v-model="tr.pro_stockCalmed" @blur="EstablecerDefaultVacio(tr, 'pro_stockCalmed')" @input="actualizarProReservar(tr)" @keypress="validateInput($event, tr)" @paste="validatePaste" maxlength="5" />
                                </vs-tooltip>
                            </vs-td>
                            <vs-td align="center">
                                <vs-tooltip :text="tr.gru_pro_codigo == 2 ? 'No disponible para GUÍAS' : 'Máx. 5 dígitos'" position="bottom" color="primary">
                                    <template>‎</template>
                                    <vs-input class="w-full hacer-click" placeholder="Cantidad" min="0" v-model="tr.pro_deposito" :disabled="tr.gru_pro_codigo == 2" @blur="EstablecerDefaultVacio(tr, 'pro_deposito')" @input="actualizarProReservar(tr)" @keypress="validateInput($event, tr)" @paste="validatePaste" maxlength="5" />
                                </vs-tooltip>
                            </vs-td>
                            <vs-td align="center">
                                <vs-tooltip :text="tr.gru_pro_codigo == 2 ? 'No disponible para GUÍAS' : 'Máx. 5 dígitos'" position="bottom" color="primary">
                                    <template>‎</template>
                                    <vs-input class="w-full hacer-click" placeholder="Cantidad" min="0" v-model="tr.pro_depositoCalmed" :disabled="tr.gru_pro_codigo == 2" @blur="EstablecerDefaultVacio(tr, 'pro_depositoCalmed')" @input="actualizarProReservar(tr)" @keypress="validateInput($event, tr)" @paste="validatePaste" maxlength="5" />
                                </vs-tooltip>
                            </vs-td>
                            <vs-td align="center">
                                <vs-button flat @click="eliminarRegistroDB(tr);" color="danger" type="relief" icon="delete">
                                    <span> Quitar</span>
                                </vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-col>
        </vs-row>
        <br><br>
        <vs-col v-if="DatosAcumuladosStockMasivo.length > 0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="guardareditarStockMasivo()" type="relief">Guardar</vs-button>&emsp;
            <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
        <br>
        <br>
        <!-- Seccion popup de errroes -->
        <vs-popup class="informacionformhijodehijo" title="Stock's insuficientes" :active.sync="popupActivoErrorStock">
            <ErroresStock v-if="popupActivoErrorStock" :erroresStock_Lista="erroresStock_Lista" @change="changeHandleErrorStock" />
        </vs-popup>
    </vx-card>
    </template>
    
    <script>
    import {
        mapState
    } from "vuex";
    import vSelect from "vue-select";
    const ErroresStock = () => import("@/views/facturacion/10_10_1_4/orden_pedido/ediciones_stock_masiva/Stocks_Insuficientes_Informacion.vue");
    export default {
        data() {
            return {
                productosFiltrados: [],
                Productos: [],
                SeriesArray: [],
                AreasxSerieArray: [],
                AreasxSerieCombosArray: [],
                DatosAcumuladosStockMasivo: [],
                productosDisponibles: [],
                pro_codigo: [],
                ProductosOriginales: [],
                ProductosxSerie_Area_Array: [],
                tipo: 0,
                tipoproducto: 1,
                tabSeleccionbusqueda: {
                    serieSeleccionada: "",
                    areaSeleccionada: "",
                },
                isrunLoading_metodoEjecucionSerie: false,
                isrunLoading_metodoEjecucionArea: false,
                usuariolocal: '',
                series_Temporal: [],
                idSerieCombos: '',
                erroresStock_Lista: [],
                popupActivoErrorStock: false,
            };
        },
        components: {
            "v-select": vSelect,
            ErroresStock,
        },
        mounted() {
            let me = this;
            me.getTodasSeries();
            me.getProductosParaStocks();
            me.getSeries();
            let usuariorespo = localStorage.getItem("usuario");
            me.usuariolocal = JSON.parse(usuariorespo);
        },
        methods: {
            radbuttonxSeleccion() {
                let me = this;
                me.changeLimpiar();
                me.getProductosParaStocks();
            },
            radbuttonxGrupos() {
                let me = this;
                me.changeLimpiar();
            },
            radbuttonxCombos() {
                let me = this;
                me.changeLimpiar();
                me.metodoEjecucionSerie();
            },
            changeLimpiar() {
                let me = this;
                me.DatosAcumuladosStockMasivo = [];
                me.tabSeleccionbusqueda.areaSeleccionada = "";
                me.tabSeleccionbusqueda.serieSeleccionada = "";
            },
            async metodoEjecucionSerie() {
                let me = this;
                if (me.tipo == 1 && me.tabSeleccionbusqueda.serieSeleccionada) {
                    try {
                        me.isrunLoading_metodoEjecucionSerie = true;
                        me.$vs.loading();
                        me.tabSeleccionbusqueda.areaSeleccionada = "";
                        await me.getAreasxSerie();
                        await me.AgregarItemsTabla2();
                        me.isrunLoading_metodoEjecucionSerie = false
                        me.$vs.loading.close();
                    } catch (error) {
                        console.error('Error en metodoEjecucionSerie:', error);
                        me.$vs.loading.close();
                    }
                } else if (me.tipo == 2) {
                    try {
                        me.isrunLoading_metodoEjecucionSerie = true;
                        me.$vs.loading();
                        me.tabSeleccionbusqueda.areaSeleccionada = "";
                        await me.getAreasxSerieCombo();
                        await me.AgregarItemsTabla2();
                        me.isrunLoading_metodoEjecucionSerie = false
                        me.$vs.loading.close();
                    } catch (error) {
                        console.error('Error en metodoEjecucionSerie:', error);
                        me.$vs.loading.close();
                    }
                } else {
                    me.DatosAcumuladosStockMasivo = [];
                }
            },
            async metodoEjecucionArea() {
                let me = this;
                if (me.tipo == 1) {
                    try {
                        me.isrunLoading_metodoEjecucionArea = true;
                        me.$vs.loading();
                        await me.AgregarItemsTabla2();
                        me.isrunLoading_metodoEjecucionArea = false
                        me.$vs.loading.close();
                    } catch (error) {
                        console.error('Error en metodoEjecucionArea:', error);
                        me.$vs.loading.close();
                    }
                } else if (me.tipo == 2) {
                    try {
                        me.isrunLoading_metodoEjecucionArea = true;
                        me.$vs.loading();
                        await me.AgregarItemsTabla2();
                        me.isrunLoading_metodoEjecucionArea = false
                        me.$vs.loading.close();
                    } catch (error) {
                        console.error('Error en metodoEjecucionArea:', error);
                        me.$vs.loading.close();
                    }
                } else {
                    console.log("RADIO BUTTON NO CONTROLADO");
                }
            },
            getSeries() {
                let me = this;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'getSeries_EdicionStock')
                    .then(function (res) {
                        me.SeriesArray = res.data.map(serie => ({
                            ...serie,
                            nombre_serie: me.ConvertiraTitleCase(serie.nombre_serie)
                        }));
                        me.$vs.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                        me.$vs.loading.close();
                    });
            },
            async getAreasxSerie() {
                let me = this;
                if (me.isrunLoading_metodoEjecucionSerie == false) {
                    me.$vs.loading();
                }
                return new Promise((resolve, reject) => {
                    me.$http.get(me.$server_url + 'GetSacarAreasxSerieProducto', {
                            params: {
                                id_serie: me.tabSeleccionbusqueda.serieSeleccionada,
                            }
                        })
                        .then(function (res) {
                            me.AreasxSerieArray = res.data
                            resolve();
                            if (me.isrunLoading_metodoEjecucionSerie == false) {
                                me.$vs.loading.close()
                            }
                        })
                        .catch(function (error) {
                            console.log(error + ' error');
                            if (me.isrunLoading_metodoEjecucionSerie == false) {
                                me.$vs.loading.close()
                            }
                            reject("getAreasxSerie", error);
                        })
                });
            },
            async getAreasxSerieCombo() {
                let me = this;
                if (me.isrunLoading_metodoEjecucionSerie == false) {
                    me.$vs.loading();
                }
                return new Promise((resolve, reject) => {
                    me.$http.get(me.$server_url + 'GetSacarAreasxSerieComboProducto', {
                            params: {
                                id_serie: me.idSerieCombos,
                            }
                        })
                        .then(function (res) {
                            me.AreasxSerieCombosArray = res.data
                            resolve();
                            if (me.isrunLoading_metodoEjecucionSerie == false) {
                                me.$vs.loading.close()
                            }
                        })
                        .catch(function (error) {
                            console.log(error + ' error');
                            if (me.isrunLoading_metodoEjecucionSerie == false) {
                                me.$vs.loading.close()
                            }
                            reject(error);
                        })
                });
            },
            EstablecerDefaultVacio(tr, field) {
                if (!tr[field] || tr[field] === '') {
                    tr[field] = 0; // Asignar valor 0 si está vacío
                }
            },
            ConvertiraTitleCase(text) {
                if (!text) return ''; // Manejar texto vacío o nulo
                return text
                    .toLowerCase()
                    .replace(/(^|\s)\S/g, char => char.toUpperCase()); // Convierte la primera letra de cada palabra
            },
            getTodasSeries() {
                let me = this;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'series')
                    .then(res => {
                        // Guardar los productos originales
                        this.series_Temporal = res.data;
                        // Asignar el id a idSerieCombos o null si no existe
                        let serieCombos = this.series_Temporal.find(serie => serie.nombre_serie === "Combos");
                        this.idSerieCombos = serieCombos ? serieCombos.id_serie : null;
                        me.$vs.loading.close();
                    })
                    .catch(err => {
                        console.log(err);
                        me.$vs.loading.close();
                    });
            },
            getProductosParaStocks() {
                let me = this;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'GetProductosSoloStocks')
                    .then(res => {
                        // Guardar los productos originales
                        this.ProductosOriginales = res.data;
                        // Agregar una nueva propiedad `nombreCompleto` a cada producto
                        this.Productos = res.data.map(producto => ({
                            ...producto,
                            nombreCompleto: `${producto.pro_nombre} - (${producto.pro_codigo})`
                        }));
                        this.actualizarProductosDisponibles(); // Inicializar opciones en el select
                        me.$vs.loading.close();
                    })
                    .catch(err => {
                        console.log(err);
                        me.$vs.loading.close();
                    });
            },
            actualizarProductosDisponibles() {
                let me = this;
                // Filtrar productos que no están en la tabla
                this.productosDisponibles = this.Productos.filter(
                    prod => !this.DatosAcumuladosStockMasivo.some(
                        p => p.pro_codigo === prod.pro_codigo
                    )
                );
            },
            AgregarItemsTabla() {
                let me = this;
                // Obtener productos seleccionados
                const productosSeleccionados = me.Productos.filter(prod =>
                    me.pro_codigo.includes(prod.pro_codigo)
                );
                // console.log(productosSeleccionados, "pordutosss");
                if (productosSeleccionados.length == 0) {
                    me.$vs.notify({
                        title: "Alerta",
                        text: "No se ha seleccionado ningún producto para añadir a la tabla.",
                        color: "danger",
                        position: "top-center",
                    });
                    return;
                }
                // Agregar productos seleccionados a la tabla
                productosSeleccionados.forEach(producto => {
                    // Verificar si el producto ya está en la tabla
                    if (!me.DatosAcumuladosStockMasivo.some(p => p.pro_codigo === producto.pro_codigo)) {
    
                        // Buscar los valores originales del producto en ProductosOriginales
                        let productoOriginal = me.ProductosOriginales.find(p => p.pro_codigo === producto.pro_codigo);
                        // console.log(productoOriginal, "porddddddd");
    
                        if (productoOriginal) {
                            // Sumar los valores de los campos pro_stock, pro_stockCalmed, pro_deposito y pro_depositoCalmed
                            let suma = (productoOriginal.pro_stock || 0) + (productoOriginal.pro_stockCalmed || 0) +
                                (productoOriginal.pro_deposito || 0) + (productoOriginal.pro_depositoCalmed || 0);
    
                            // Obtener el valor de pro_reservar si existe en el producto
                            let pro_reservar_anterior = producto.pro_reservar || 0; // Asigna 0 si no existe pro_reservar
                            let pro_stock_anterior = producto.pro_stock || 0; // Asigna 0 si no existe pro_stock
                            let pro_stockCalmed_anterior = producto.pro_stockCalmed || 0; // Asigna 0 si no existe pro_stockCalmed
                            let pro_deposito_anterior = producto.pro_deposito || 0; // Asigna 0 si no existe pro_deposito
                            let pro_depositoCalmed_anterior = producto.pro_depositoCalmed || 0; // Asigna 0 si no existe pro_depositoCalmed
    
                            // Agregar el producto con la suma calculada
                            me.DatosAcumuladosStockMasivo.push({
                                ...productoOriginal, // Se usa el valor original sin modificación
                                sumainicial: suma, // Se agrega la suma calculada al objeto
                                valornuevosumado: suma,
                                calculoaplicara_pro_reservar: 0,
                                pro_reservar_anterior: pro_reservar_anterior,
                                pro_stock_anterior: pro_stock_anterior,
                                pro_stockCalmed_anterior: pro_stockCalmed_anterior,
                                pro_deposito_anterior: pro_deposito_anterior,
                                pro_depositoCalmed_anterior: pro_depositoCalmed_anterior
                            });
                            // console.log(me.DatosAcumuladosStockMasivo, "dataj");
                        }
                    }
                    // console.log(me.DatosAcumuladosStockMasivo, "data nuewwwwww");
                });
                // Limpiar selección después de agregar y actualizar productos disponibles
                me.pro_codigo = []; // Limpiar v-model del select
                me.actualizarProductosDisponibles();
            },
            async AgregarItemsTabla2() {
                let me = this;
                let datosaenviar = {}; // Definir fuera del if
                // console.log(me.tabSeleccionbusqueda.serieSeleccionada, "222", me.tabSeleccionbusqueda.areaSeleccionada, "valores")
                return new Promise((resolve, reject) => {
                    if (me.tipo == 1) {
                        datosaenviar = {
                            "id_serie": me.tabSeleccionbusqueda.serieSeleccionada,
                            "idarea": me.tabSeleccionbusqueda.areaSeleccionada,
                            "tipo_producto": me.tipoproducto,
                            "tipo": me.tipo
                        }
                    } else if (me.tipo == 2) {
                        datosaenviar = {
                            "id_serie": me.idSerieCombos,
                            "idarea": me.tabSeleccionbusqueda.areaSeleccionada,
                            "tipo_producto": 4, //Solo Textos
                            "tipo": me.tipo
                        }
                    }
                    if (me.isrunLoading_metodoEjecucionSerie == false) {
                        me.$vs.loading();
                    }
                    me.$http.get(me.$server_url + 'GetObtenerProductosxSerieoArea', {
                            params: datosaenviar
                        })
                        .then(function (res) {
                            if (res.data.error) { // Si la API devuelve un error en la respuesta
                                me.DatosAcumuladosStockMasivo = [];
                                me.$vs.notify({
                                    text: 'No se encontraron productos',
                                    color: 'warning',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-triangle',
                                    time: 7000
                                });
                                return resolve();
                            }
                            me.DatosAcumuladosStockMasivo = res.data;
                            me.DatosAcumuladosStockMasivo.forEach(producto => {
                                let suma = (producto.pro_stock || 0) +
                                    (producto.pro_stockCalmed || 0) +
                                    (producto.pro_deposito || 0) +
                                    (producto.pro_depositoCalmed || 0);
    
                                // Asignar la suma a la variable sumainicial
                                producto.sumainicial = suma;
                                producto.valornuevosumado = suma;
                                producto.calculoaplicara_pro_reservar = 0;
                                producto.pro_reservar_anterior = producto.pro_reservar || 0;
                                producto.pro_stock_anterior = producto.pro_stock || 0;
                                producto.pro_stockCalmed_anterior = producto.pro_stockCalmed || 0;
                                producto.pro_deposito_anterior = producto.pro_deposito || 0;
                                producto.pro_depositoCalmed_anterior = producto.pro_depositoCalmed || 0;
                            });
                            // console.log(me.DatosAcumuladosStockMasivo, "ediciondegrupos");
                            if (me.isrunLoading_metodoEjecucionSerie == false) {
                                me.$vs.loading.close()
                            }
                            resolve();
                        })
                        .catch(function (error) {
                            console.log(error, ' error');
                            if (!me.isrunLoading_metodoEjecucionSerie) {
                                me.$vs.loading.close();
                            }
    
                            if (error.response && error.response.status === 404) { // Si la API responde con un 404
                                me.DatosAcumuladosStockMasivo = [];
                                me.$vs.notify({
                                    text: 'No se encontraron productos',
                                    color: 'warning',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-triangle',
                                    time: 7000
                                });
                                return resolve();
                            }
    
                            reject("AgregarItemsTabla2", error);
                        });
                });
            },
            eliminarRegistroDB(tr) {
                let me = this;
                // Eliminar el producto de la tabla
                this.DatosAcumuladosStockMasivo = this.DatosAcumuladosStockMasivo.filter(
                    item => item.pro_codigo !== tr.pro_codigo
                );
    
                me.$vs.notify({
                    text: 'Producto quitado de la tabla con éxito',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
    
                // Actualizar los productos disponibles para incluir el producto eliminado
                this.actualizarProductosDisponibles();
            },
            validatePaste(event) {
                const clipboardData = event.clipboardData || window.clipboardData;
                const pastedText = clipboardData.getData('text/plain');
    
                // Filtrar solo los números del texto pegado
                const numbersOnly = pastedText.replace(/[^\d]/g, '');
    
                // Insertar el texto filtrado en la posición del cursor
                document.execCommand("insertText", false, numbersOnly);
    
                // Prevenir la acción de pegar por defecto
                event.preventDefault();
            },
            validateInput(event, tr) {
                const charCode = event.which ? event.which : event.keyCode;
    
                // Permitir solo números
                if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                }
    
                // Obtener el valor actual del input
                const currentValue = event.target.value;
    
                // Obtener el valor potencial si el nuevo carácter es agregado
                const newValue = parseInt(currentValue + String.fromCharCode(charCode));
    
            },
            // Método para actualizar `pro_reservar` automáticamente
            actualizarProReservar(tr) {
                // console.log(tr,"trrrrrrrr");
                // Calcula la suma y asigna el resultado a `pro_reservar`
                tr.valornuevosumado = (Number(tr.pro_stock) || 0) +
                    (Number(tr.pro_stockCalmed) || 0) +
                    (Number(tr.pro_deposito) || 0) +
                    (Number(tr.pro_depositoCalmed) || 0);
    
                tr.calculoaplicara_pro_reservar = tr.valornuevosumado - tr.sumainicial;
                tr.pro_reservar = tr.pro_reservar_anterior + tr.calculoaplicara_pro_reservar;
            },
            guardareditarStockMasivo() {
                let me = this;
                let datosParaGuardar = {};
                let periodo_id = localStorage.getItem('periodo_id');
                // console.log(me.DatosAcumuladosStockMasivo, "datos compeltos final");
                if (me.tipo == 0 || me.tipo == 1) {
                    // Si me.tipo es 0 o 1, usar la estructura base
                    datosParaGuardar = {
                        DatosAcumuladosStockMasivo: me.DatosAcumuladosStockMasivo,
                        user_created: me.usuariolocal.idusuario,
                    };
                } else if (me.tipo == 2) {
                    // Si me.tipo es 2, añadir campos extra
                    datosParaGuardar = {
                        DatosAcumuladosStockMasivo: me.DatosAcumuladosStockMasivo,
                        user_created: me.usuariolocal.idusuario,
                        EdicionCombos: 'yes',
                        periodo_id: periodo_id,
                        user_iniciales: me.usuariolocal.iniciales,
                        // Aquí puedes seguir agregando más campos extra
                    };
                }
                // console.log(datosParaGuardar, "ffffffffffffffffffff");
                // return
                me.$vs.loading();
                me.$http.post(me.$server_url + 'GuardarDatosEdicionStockMasiva', datosParaGuardar)
                    .then(res => {
                        // me.obtenerDetalleMovimientoVenta();
                        // console.log("Respuesta completa:", res.data);
                        me.$vs.loading.close();
                        if (res.data.status == 1) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                time: 7000,
                            })
                            this.$emit('change', {
                                verificaredicionmasivaactualizar: 1
                            });
                        } else if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle',
                                time: 7000,
                            })
                            this.$emit('change', {
                                verificaredicionmasivaactualizar: 1
                            });
                        } else if (res.data.status == 3) {
                            me.erroresStock_Lista = res.data;
                            me.popupActivoErrorStock = true;
                            // console.log('Capturo estado 3');
                        }
                    })
                    .catch(error => {
                        console.error('Error al guardar los datos:', error);
                        me.$vs.loading.close();
                        me.$vs.notify({
                            text: 'No se puede guardar, complete la información de los productos añadidos',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x',
                            time: 7000,
                        })
                        return
                    });
            },
            changeHandleErrorStock(e) {
                let me = this;
                if (e.verificacionemitdeerrorlistado == 2) {
                    me.popupActivoErrorStock = false;
                    console.log("Emit recibido por cancelar.")
                } else if (e.verificacionemitdeerrorlistado == 1) {
                    me.popupActivoErrorStock = false;
                }
            },
            getCancelar() {
                this.$emit('change', {
                    verificaredicionmasivaactualizar: 2
                });
            },
        },
    };
    </script>
    <style scoped>
    .informacionformhijodehijo {
            z-index: 51002;
            /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
            /* position: fixed; */
            /* Asegúrate de que la posición sea adecuada */
        }
    </style>